import { APPROVAL_LIST, SITE_ABORT_APPROVAL, ACCEPT,SITE_ABORT_APPROVAL_FINANCE, FETCH_APPROVE_REJECT_LIST } from "./type";

const initalState = {
    approvalList: {},
    siteAbortApproval: {},
    accept: [],
    siteAbortApprovalFinance: {},
    fetchApproveRejectListForFinance: {},
};

const mrfApprovalReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case APPROVAL_LIST:
            return {
                ...state,
                approvalList: payload,
            };
        case SITE_ABORT_APPROVAL:
            return {
                ...state,
                siteAbortApproval: payload,
            };
        case SITE_ABORT_APPROVAL_FINANCE:
            return {
                ...state,
                siteAbortApprovalFinance: payload,
            };    
        case ACCEPT:
            return {
                ...state,
                accept: payload,
            };
        case FETCH_APPROVE_REJECT_LIST:
            return {
                ...state,
                fetchApproveRejectListForFinance: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default mrfApprovalReducer;
